export default __webpack_public_path__ + "static/leader_3-cf6b999fe73a0546b203a77ebcca7c38.png";